import { useCollection } from "@/hooks/useCollection";
import CommentList from "../../components/CommentList";
import { useDocument } from "@/hooks/useDocument";
import { useAuthContext } from "@/hooks/useAuthContext";
import Loading from "@/components/Loading";
import { useUserContext } from "@/hooks/useUserContext";

export default function ManageComments() {
  const { user } = useAuthContext();
  const { documents: comments } = useCollection(
    "comments",
    ["deleted", "==", false],
    ["createdAt", "desc"]
  );
  const { documents: lessons } = useCollection("lessons");
  const { userDoc } = useUserContext();

  if (!comments) return <Loading />;

  return (
    <div>
      <div className="flex justify-between mb-10">
        <h1 className="font-semibold text-2xl">Gerenciar comentários</h1>
        <div className="invisible"></div>
      </div>
      <CommentList
        comments={comments}
        userDoc={userDoc}
        lessons={lessons}
        lessonId="admin"
      />
    </div>
  );
}
